<template>
<modal name="modal-display-working-hours" :width="350" :height="'auto'" scrollable @before-open="beforeOpen">
    <div class="text-center rounded-lg bg-white p-10 relative">
        <div class="right-2 top-2 p-2 absolute">
            <button @click="$modal.hide('modal-display-working-hours')" class="text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
        </div>
        <div>
            <div class="text-lg font-medium" v-text="title"></div>
            <div class="text-lg font-light mt-2" v-html="text"></div>
        </div>

        <div class="flex flex-col-reverse gap-2" v-if="schedule">
            <div v-for="day in schedule.days" class="bg-gray-100 rounded-lg p-2">
                <div v-if="day.is_holiday" class="text-red-500">
                    {{ $root.getKeyWord('is_holiday_or_noneworkday') }}
                </div>
                <div class="flex flex-col gap-2 justify-center items-start">
                    <div>{{ formatTime(day.start_time) + ' - ' + formatTime(day.end_time) }}</div>
                    <div class="flex items-start gap-1">                        
                        <div class="rounded-full text-[8px] w-6 h-6 flex justify-center items-center" 
                            :class="[one ? 'bg-lime-500  text-white' : 'bg-gray-200 text-black']"
                            v-for="(one, index) in day.days" v-if="index !== 0">{{ $root.formatWeekDay(index) }}</div>
                        <div class="rounded-full text-[8px] w-6 h-6 flex justify-center items-center" 
                            :class="[day.days[0] ? 'bg-lime-500  text-white' : 'bg-gray-200 text-black']">{{ $root.formatWeekDay(0) }}</div>                            
                    </div>
                    <div class="flex items-start">             
                        <div class="w-full">
                            <div v-if="day.start_date">
                                {{ day.start_date }}
                            </div>
                            <div v-if="day.end_date">
                                {{ day.end_date }}
                            </div>
                        </div>                    
                    </div>                    
                </div>                
            </div>     
        </div>   
    </div>   
</modal>
</template>

<script>
export default {
    data() {
        return {
            text: null,
            title: null,
            schedule: null,
        }
    },

    methods: {
        beforeOpen(event) {
            this.text = event.params.text;
            this.title = event.params.title;
            this.schedule = event.params.schedule;
        },

        formatTime(time) {
            var splitTime = time.split(':');
            return splitTime.length > 2 ? splitTime[0] + ':' + splitTime[1] : time;
        }        
    }
}
</script>